// export const base_path ='/react/template'
// export const img_path ='/react/template/'

export const base_path = "/";
export const img_path = "/";
